// @ts-nocheck
import { populate } from 'populate';
import type { Container, Text } from 'pixi.js';

const raw = {
  list: [
    {
      id: 'a8cad549-c5df-4e05-8fad-a5bd84f30b0e',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: '840d1b05-87da-4626-bc2a-8287305f5007',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 8.91,
        y: 3.89
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Black_Blur_Square',
      parent: 'a8cad549-c5df-4e05-8fad-a5bd84f30b0e'
    },
    {
      id: 'ac3358d9-47bc-4040-879c-3ac04ee0c13a',
      type: 'Text',
      name: '',
      className: 'variable_SPL',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '<loadingSpinner>',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'Arial',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'a8cad549-c5df-4e05-8fad-a5bd84f30b0e'
    }
  ],
  x: 0,
  y: 0,
  width: 760,
  height: 760,
  version: '4.0.1',
  handleResize: false
} as const;

export class ShopLoadingOfferLayout {
  static raw = raw;
  root!: Container;
  variable_SPL!: (Text)[];
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}
